module.exports = __webpack_public_path__ + "static/media/card-CUP.628fe7a9.svg";